// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__12L5B","col":"styles_col__1pw9c"};